import { marketSearchApi, Site } from '@envato/foundation-types'
import get from 'lodash-es/get'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import FilterMultiselect from '../filterMultiselect'

const rankMap = {
  'rank-0': 'No sales',
  'rank-1': 'Low',
  'rank-2': 'Medium',
  'rank-3': 'High',
  'rank-4': 'Top Sellers'
}

interface IProps extends RouteComponentProps<any> {
  items: marketSearchApi.IFilterOption[]
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const FiltersSales = ({
  locationParams,
  makeSearchLink,
  history,
  items
}: IProps) => {
  const getFormattedOptions = (options: marketSearchApi.IFilterOption[]) => {
    return options.map(option => {
      return {
        label: get(rankMap, option.key),
        ...option
      }
    })
  }

  return (
    <FilterMultiselect
      type="sales"
      items={getFormattedOptions(items)}
      locationParams={locationParams}
      makeSearchLink={makeSearchLink}
      history={history}
    />
  )
}

export const FiltersSalesComponent = FiltersSales
export default withRouter(FiltersSales)
